import { useEffect, useState } from "react";
import "./NewsLetter.scss";
import DynamicDownloadBtnSection from "../../components/DynamicDownloadBtnSection/DynamicDownloadBtnSection";
import { useContext } from "react";
import { AppContext } from "../../context/AppContext";
import axios from "axios";
import { toast } from "react-toastify";

const NewsLetter = () => {

  const { backendUrl } = useContext(AppContext);
  const [allNewsletterReports, setAllNewsletterReports] = useState([]);
   let errorShown = false;

  async function fetchAllNewsletterReports() {
    try {
      const { data } = await axios.get(`${backendUrl}/api/auth/getAllNewsletter`);
      if (data.success) {
        setAllNewsletterReports(data || []);
      }
      errorShown = false;  
    } catch (error) {
      if (errorShown) return;
            errorShown = true;
      if (error.response && error.response.status === 503) {
                      toast.error("⚠️ The service is currently under maintenance. Please try again later.");
                  }
                  else if (!navigator.onLine) {
                      toast.error("🚫 No internet connection. Please check your network.");
                  }
      
                  else if (error.request && !error.response) {
                      toast.error("⚠️ Network issue or server is unreachable. Try again later.")
                  }
                  else 
                  {
                      console.error("Unexpected error:", error);
                      toast.error("Something went wrong.");
                  }
    }
  }

  useEffect(() => {
    fetchAllNewsletterReports();
  }, [])

  const content = allNewsletterReports?.reports
    ?.filter(item => item.isActive)
    .map(item => ({
      filename: item.filename,
      data: item.data,
      contentType: item.contentType,
    })) || [];


  return (
    <section className="newsLetterMainContainer">
      <header className="newsLetterHeader">
        <h2>News Letter </h2>
      </header>

      <DynamicDownloadBtnSection
        items={content}
        yearFontSize={1.25}
      />
      
    </section>
  );
};

export default NewsLetter;
